import {Component} from "@angular/core";
import {FUIAbstractLoader} from "../abstract-loader";

@Component({
    selector: "fui-dotted-loader",
    styleUrls: ["./dotted-loader.component.scss"],
    templateUrl: "./dotted-loader.component.html",
    standalone: false
})
export class FUIDottedLoaderComponent extends FUIAbstractLoader {
}
